export default "__VITE_ASSET__39d99007__"